import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import nationalIllustrationEn from "@/assets/en/trajectory-illustrations/national.png";
import nationalIllustrationFr from "@/assets/fr/trajectory-illustrations/national.png";
import PedagogicLink from "@/components/PedagogicLink";
import { cn } from "@/utils/classes";

function NationalTargets({ fullWidth = false }: { fullWidth?: boolean }) {
  const { t, i18n } = useTranslation(["trajectory"]);

  return (
    <div
      className={cn("gap-lg", fullWidth ? "flex flex-col" : "grid grid-cols-2")}
    >
      <img
        src={
          i18n.language === "fr"
            ? nationalIllustrationFr
            : nationalIllustrationEn
        }
        alt={t("trajectory:pedagogy.targets.national.illustrationAltText")}
      />
      <div className={cn("flex flex-col", fullWidth ? "gap-lg" : "gap-sm")}>
        <Typography step="-1">
          {t("trajectory:pedagogy.targets.national.introduction")}
        </Typography>
        <div>
          <Typography as="h3" weight="bold" className="mb-2xs">
            {t("trajectory:pedagogy.targets.national.until2030")}
          </Typography>
          <Typography step="-1">
            {t("trajectory:pedagogy.targets.national.until2030Text")}
          </Typography>
        </div>
        <div>
          <Typography as="h3" weight="bold" className="mb-2xs">
            {t("trajectory:pedagogy.targets.national.between2030And2050")}
          </Typography>
          <Typography step="-1">
            {t("trajectory:pedagogy.targets.national.between2030And2050Text")}
          </Typography>
        </div>
        <div>
          <PedagogicLink
            text={t("trajectory:pedagogy.targets.helpCenterText")}
            href="https://hellocarbo-25361575.hs-sites-eu1.com/knowledge/carbo-objectifs-de-reduction#obj-nationaux"
          />
        </div>
      </div>
    </div>
  );
}

export default NationalTargets;
